import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { apiCaller } from "../../custom-hooks/useApi";
import { profile_apiCalls } from "../../services/agent";

import { set_expiration_data_Action } from "../../redux/actions/userProfileActions";

const useCheckAccountExpiration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { token } = useSelector((store) => store.userReducer);
  const { expirationData } = useSelector((store) => store.userProfileReducer);

  useEffect(() => {
    if (token) {
      apiCaller({
        api: profile_apiCalls.apiCall_getAccountStatus,
        apiArguments: 1,
        onSuccess: (resp) => {
          dispatch(set_expiration_data_Action(resp.data.data));

          if (
            resp.data.data.isExpired &&
            location.pathname !== "/accountexpired"
          ) {
            navigate("/accountexpired");
          }
        },
      });
    }
  }, [token]);

  useEffect(() => {
    if (
      token &&
      expirationData &&
      expirationData?.isExpired &&
      location.pathname !== "/accountexpired"
    ) {
      navigate("/accountexpired");
    }
    if (
      token &&
      expirationData &&
      !expirationData?.isExpired &&
      location.pathname === "/accountexpired"
    ) {
      navigate("/", { replace: true });
    }
  }, [token, expirationData, location]);
};

export default useCheckAccountExpiration;
